import NotesRecord from './record'
import * as NotesActions from './actions'
import * as NotesSelectors from './selectors'

export const actions = NotesActions
export const selectors = NotesSelectors
export const record = NotesRecord

const { ALL_NOTES_LIST_NAME, ALL_ARCHIVED_NOTES_LIST_NAME } = selectors

export default {
  NotesRecord,
  NotesActions,
  NotesSelectors,
  ALL_NOTES_LIST_NAME,
  ALL_ARCHIVED_NOTES_LIST_NAME,
}
